module.exports = __webpack_public_path__ + "img/multiplier_normal_3.61a47866.png";